import { render, staticRenderFns } from "./duplicate.vue?vue&type=template&id=accc3674&lang=pug&"
import script from "./duplicate.vue?vue&type=script&lang=js&"
export * from "./duplicate.vue?vue&type=script&lang=js&"
import style0 from "./duplicate.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('accc3674')) {
      api.createRecord('accc3674', component.options)
    } else {
      api.reload('accc3674', component.options)
    }
    module.hot.accept("./duplicate.vue?vue&type=template&id=accc3674&lang=pug&", function () {
      api.rerender('accc3674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/duplicate.vue"
export default component.exports